export default __webpack_public_path__ + "static/media/gymImg.ec1d4898.jpeg";